// extracted by mini-css-extract-plugin
export default {"block":"Star_block__zMXzx","title":"Star_title__vck57","subtitle":"Star_subtitle__4yFIq","small":"Star_small__4+9As","mixed":"Star_mixed__g9cM8","normal":"Star_normal__ysruP"};